// extracted by mini-css-extract-plugin
export default {"PasswordBox":"styles_PasswordBox__TElmF","IncorrectPasswordBox":"styles_IncorrectPasswordBox__35XVO styles_PasswordBox__TElmF","doShake":"styles_doShake__cRnAe"};